<script>
import Layout from "@/router/layouts/main";
import { mapState } from "vuex";
import { api } from "@/state/services";
import Stat from "@/components/widgets/stat";

export default {
  locales: {
    pt: {
    },
    es: {
    }
  },
  components: {
    Layout,
    Stat,
  },
  computed: {
    ...mapState({
      account: state => state.account
    })
  },
  data() {
    return {
      statData: [
        { type: "line", title: "Items", value: "-", icon: "bx-purchase-tag-alt", },
        { type: "line", title: "Total", value: "R$ -,---", icon: "bx-box", },
      ],

      total: {
        active: 0,
        inactive: 0,
        draft: 0,
      },

      fields: [
        { key: "image", label: "#" },
        { key: "sku", label: "SKU" },
        { key: "name", label: "Nome" },
        { key: "inventory", label: "Disponível" },
        { key: "reserved", label: "Reservado" },
        { key: "total", label: "Total" },
      ],
      items: null,

      sortBy: "name",
      sortDesc: false,
    };
  },
  methods: {
    getInventory() {
      this.items = null;

      api
        .get("inventory")
        .then((response) => {
          if (response.data.status == "success") {
            this.total = response.data.total;
            this.items = response.data.list;

            this.statData = [
              { type: "line", title: "Items", value: this.total.items.toString(), icon: "bx-purchase-tag-alt", },
              { type: "line", title: "Total", value: this.$options.filters.currency(this.total.real).toString(), icon: "bx-box", },
            ];
          } else {
            this.total = 0;
            this.items = [];
          }
        })
        .catch((error) => {
          if (error) {
            this.total = 0;
            this.items = [];
          }
        })
    },
  },
  mounted() {
    this.getInventory();
  }
};
</script>

<template>
  <Layout>
    <ol class="breadcrumb">
      <li class="breadcrumb-item">
        <router-link tag="a" to="/inventory">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1);">
            <path d="M5 22h14a2 2 0 0 0 2-2v-9a1 1 0 0 0-.29-.71l-8-8a1 1 0 0 0-1.41 0l-8 8A1 1 0 0 0 3 11v9a2 2 0 0 0 2 2zm5-2v-5h4v5zm-5-8.59 7-7 7 7V20h-3v-5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v5H5z">
            </path>
          </svg>
        </router-link>
      </li>
      <li class="breadcrumb-item"><router-link tag="a" to="/inventory">Estoque</router-link></li>
    </ol>

    <div class="page-title-box d-md-flex justify-content-between">
      <div>
        <h3>Produtos</h3>
        <p></p>
      </div>
    </div>

    <div class="row">
      <div v-for="stat of statData" :key="stat.icon" class="col-md-6 col-lg-3 col-xl-3">
        <Stat :type="stat.type" :icon="stat.icon" :title="stat.title" :value="stat.value" />
      </div>
    </div>

    <div v-if="!items" class="card">
      <div class="card-body min-vh-25 d-flex justify-content-center align-items-center">
        <b-spinner variant="default" role="status"></b-spinner>
      </div>
    </div>

    <div class="card" v-else-if="items && items.length == 0">
      <div class="card-body min-vh-25 d-flex justify-content-center align-items-center">
        <div class="text-center">
          <i class="far fa-sad-cry font-size-24"></i><br>
          nenhum produto encontrado
        </div>
      </div>
    </div>

    <div v-else class="card">
      <div class="card-body">
        <div class="table-responsive">
          <b-table :items="items" :fields="fields" class="table-nowrap table-style table-hover min-vh-25" head-variant="light" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc"
            responsive>
            <template #cell(image)="row">
              <img :src="row.item.image" class="avatar-md rounded">
            </template>
            <template #cell(price_affiliate)="row">
              {{ row.item.price_affiliate | currency }}
            </template>
            <template #cell(price_franchise)="row">
              {{ row.item.price_franchise | currency }}
            </template>
            <template #cell(status)="row">
              <span v-if="row.item.status == 'inactive'" class="bg-danger rounded py-2 px-3 font-size-12 text-white">INATIVO</span>
              <span v-else-if="row.item.status == 'active'" class="bg-success rounded py-2 px-3 font-size-12 text-white">ATIVO</span>
              <span v-else-if="row.item.status == 'draft'" class="bg-dark rounded py-2 px-3 font-size-12 text-white">RASCUNHO</span>
            </template>
            <template #cell(actions)="row">
              <svg v-if="row" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1);">
                <path d="M12 9a3.02 3.02 0 0 0-3 3c0 1.642 1.358 3 3 3 1.641 0 3-1.358 3-3 0-1.641-1.359-3-3-3z"></path>
                <path
                  d="M12 5c-7.633 0-9.927 6.617-9.948 6.684L1.946 12l.105.316C2.073 12.383 4.367 19 12 19s9.927-6.617 9.948-6.684l.106-.316-.105-.316C21.927 11.617 19.633 5 12 5zm0 12c-5.351 0-7.424-3.846-7.926-5C4.578 10.842 6.652 7 12 7c5.351 0 7.424 3.846 7.926 5-.504 1.158-2.578 5-7.926 5z">
                </path>
              </svg>
            </template>
          </b-table>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style>
.p-editor-container .p-editor-toolbar.ql-snow {
  border-color: #D1D1E3;
}

.p-editor-container .p-editor-content.ql-snow {
  border-color: #D1D1E3;
}

.p-editor-container .p-editor-toolbar {
  background: #fff;
}

.p-editor-content .ql-editor {
  font-family: Poppins;
  font-size: 15px;
  color: #131313;
}

.p-editor-content .ql-editor strong {
  font-weight: bold;
}

.p-editor-content .ql-editor p {
  margin-bottom: 15px;
}

.p-editor-content .ql-editor ul {
  margin-left: 0px;
  margin-bottom: 15px;
}

.p-editor-content .ql-editor ul li {
  padding-left: 0px;
  line-height: 25px;
}
</style>